import { render, staticRenderFns } from "./UserFeedbackList.vue?vue&type=template&id=724060af&scoped=true"
import script from "./UserFeedbackList.vue?vue&type=script&lang=js"
export * from "./UserFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./UserFeedbackList.vue?vue&type=style&index=0&id=724060af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724060af",
  null
  
)

export default component.exports